import { Navigate, useParams, useRoutes } from "react-router-dom";

import CorrespondenceEditPage from "./correspondence/edit";
import CorrespondencePage from "./correspondence/list";
import CorrespondenceViewPage from "./correspondence/view";

import InvoiceRoutes from "./invoice/routes";
import UsagePage from "./usage";

export default () =>
  useRoutes([
    { path: "/usage/:ymd", element: <WithParameters component={UsagePage}/> },
    { path: "/usage", element: <WithParameters component={UsagePage}/> },
    { path: "/correspondence/:correspondenceId/:edit", element: <WithParameters component={CorrespondenceEditPage}/> },
    { path: "/correspondence/:correspondenceId", element: <WithParameters component={CorrespondenceViewPage}/> },
    { path: "/correspondence", element: <WithParameters component={CorrespondencePage}/> },
    { path: "/invoice/*", element: <InvoiceRoutes/> },
    { path: "/", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
